const routes = {
	base: '/ovv-cabinet',
	notifications: '/ovv-cabinet/notifications',
	notifications__item: '/ovv-cabinet/notifications/:notificationId',
	settings: '/ovv-cabinet/settings',
};

export default routes;
